import { TFunction } from 'i18next'
import { FieldType, IFormConfig } from 'types'
import { IndividualsForm, individualsSchema } from './individuals-schema'
import { IndividualsField } from 'components/IndividualsField'

export const getIndividualsConfig = (
  t: TFunction
): IFormConfig<IndividualsForm> => ({
  schema: individualsSchema,
  fields: [
    {
      name: 'individuals',
      type: FieldType.CUSTOM,
      label: t('individuals.fields.individuals.label'),
      CustomComponent: IndividualsField
    }
  ]
})
